import React, { Component } from 'react';
import { array, bool, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import transformFeatureFlags from '../../lib/featureFlags';
import Logo from './Logo';
import NavSection from './NavSection';
import NavToggle from './NavToggle';
import apiClient from 'ps-components/lib/apiClient';
import './NavPanel.scss';
import { isProduction } from '../../lib/helpers';
import { SFCONNECT } from './constants';

const IFRAME_URL = `/iframe/merit`;
const SECTIONS = {
  MARKET_ANALYSIS: 'analysis',
  DASHBOARD: 'dashboard',
  REPORTS: 'reports',
  MODELING: 'modeling',
  JDXPERT: 'jdxpert',
  OUR_DATA: 'data',
  PAYSCALE_PULSE: 'pulse',
  ADMIN: 'admin',
  HELP: 'help',
  RESEARCH: 'research'
};

class NavPanel extends Component {
  static propTypes = {
    featureFlags: array,
    launchDarklyFeatureFlags: object,
    isNotIframed: bool,
    navCollapsed: bool,
    session: object,
    toggleCollapse: func,
    showSlideout: func
  };

  state = { section: null };

  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { section } = this.state;
    const { isNotIframed } = this.props;
    if (isNotIframed !== nextProps.isNotIframed) {
      this.hideSection();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.featureFlags !== nextProps.featureFlags || this.state !== nextState || this.props !== nextProps;
  }

  hideSection = () => {
    this.setState({ section: null });
  };

  showSection = index => {
    this.setState({ section: index });
  };

  toggleCollapse = event => {
    const { toggleCollapse } = this.props;

    toggleCollapse(event);
    this.hideSection();
  };

  goToPayScalePulse = () => {
    const { history } = this.props;
    history.push('/market-analysis/differentials-engine/');
  };

  goToDashboard = () => {
    const { history } = this.props;
    history.push('/landing-page');
  };

  goToJDXpert = () => {
    const { history } = this.props;
    history.push('/jdxpert');
  };

  goToPSResearch = () => {
    window.open('https://www.payscale.com/data', '_blank');
  };

  goToUserVoice = async (maid) => {
    try {
      const res = await apiClient.get(`/cms/api/accounts/${maid}/userSSOToken`)
      window.open(`https://payscale.uservoice.com/forums/961088-marketpay?sso=${res.data.data.token}`, '_blank');
    } catch(err) {
      console.error('Error getting user token for auto login to UserVoice: ', err);
      window.open('https://payscale.uservoice.com/forums/961088-marketpay', '_blank');
    }

  }

  render() {
    const { session, isNotIframed, navCollapsed, launchDarklyFeatureFlags, showSlideout } = this.props;
    const { section } = this.state;
    const groupId = session.group.id;
    const orgId = session.organization.id;
    const orgDefaultGroupId = session.organization.defaultGroup.id;
    const {
      globalAdmin,
      groupAdmin,
      siteAdmin,
      superAdmin,
      readOnlyUser,
      restrictedUser,
      reportViewUser
    } = session.user.rights;
    const { groupAdminsHrisUploads } = session;
    const showEditSurveySources = superAdmin && orgId == '5919';
    const adminOrMarketPayAdmin = siteAdmin || globalAdmin;
    const isAnyAdmin = superAdmin || globalAdmin || siteAdmin || groupAdmin;
    const sameOrgAndGroup = groupId === orgDefaultGroupId;
    const dynamicSalaryRangeToken = session.replacementTokens.find(token => token.token === 'mrr_text');
    const dynamicSalaryRangeLabel = dynamicSalaryRangeToken.value;
    const featureFlags = transformFeatureFlags(this.props.featureFlags);
    let {
      showLibraryUpdate = false,
      showPricing = false,
      showGlobalJobPricing = false,
      showDataAnalytics = false,
      showDataMining = false,
      showReports = false,
      showReportLibrary = false,
      showParticipationCenter = false,
      showStructureModeling = false,
      showModelingMatrix = false,
      showConfiguration = false,
      showGroupAdmin = false,
      showGroupAdminSiteAdmin = false,
      showUserAdmin = false,
      showJobBasedRanges = false,
      showBrowseSurveyLibrary = true,
      showPrivateSurveySources = true,
      showPrivateSurveyJobs = true,
      showEmployees = true,
      showJobs = true,
      showStructures = true,
      showUploadHRISData = true,
      showUploadSurveyData = true
    } = featureFlags;

    const isReportViewer = reportViewUser;
    const isLimitedUser = isReportViewer || restrictedUser;
    if (!siteAdmin && !superAdmin) {
      showLibraryUpdate = false;
    }

    if (readOnlyUser || restrictedUser) {
      showStructureModeling = false;
      showModelingMatrix = false;
      showJobBasedRanges = false;
    }

    if (isReportViewer || restrictedUser) {
      showLibraryUpdate = false;
      showPricing = false;
      showDataAnalytics = false;
      showDataMining = false;
      showParticipationCenter = false;
      showStructureModeling = false;
      showModelingMatrix = false;
      showConfiguration = false;
      showGroupAdmin = false;
      showGroupAdminSiteAdmin = false;
      showUserAdmin = false;
      showJobBasedRanges = false;
      showBrowseSurveyLibrary = false;
      showPrivateSurveySources = false;
      showPrivateSurveyJobs = false;
      showEmployees = false;
      showJobs = false;
      showStructures = false;
      showUploadHRISData = false;
      showUploadSurveyData = false;
    }

    if (!adminOrMarketPayAdmin && groupAdmin && !groupAdminsHrisUploads) {
      showUploadHRISData = false;
    }

    if (restrictedUser) {
      showPricing = true;
      showReportLibrary = false;
    }

    if (adminOrMarketPayAdmin) showGlobalJobPricing = true;
    showReports = showReportLibrary || showDataMining || showDataAnalytics;

    const showGroupAdminLink =
      (superAdmin && showGroupAdmin) || (sameOrgAndGroup && adminOrMarketPayAdmin && showGroupAdminSiteAdmin);
    const showGroupConfigLink = !sameOrgAndGroup;
    const showUserAdminLink = showUserAdmin && adminOrMarketPayAdmin;
    const showSystemConfig = sameOrgAndGroup && adminOrMarketPayAdmin && showConfiguration;
    let showRulesBasedPricing =
      !readOnlyUser &&
      !restrictedUser &&
      !isReportViewer &&
      session.featureFlags.find(flag => flag.name === 'showRulesBasedPricing').enabled;
    const systemConfigSearch = '?initial_tab=configuration&selected_group_id=${groupId}';
    const userAdminSearch = '?initial_tab=users&selected_group_id=${groupId}';
    const groupConfigSearch = '?initial_tab=configuration&selected_group_id=${groupId}';

    // Enable menu parents that have any children enabled
    const showModeling = showStructureModeling || showModelingMatrix || showJobBasedRanges;
    const showMarketAnalysis =
      showPricing ||
      showBrowseSurveyLibrary ||
      showParticipationCenter ||
      showEditSurveySources ||
      showPrivateSurveySources ||
      showPrivateSurveyJobs ||
      showRulesBasedPricing;
    const showOurData = showEmployees || showJobs || showStructures;
    const showAdmin = showSystemConfig || showUserAdminLink || showGroupConfigLink;
    const showJDXpert =
      session.organization?.accountMetaData?.enableHRTMSIntegration &&
      !readOnlyUser &&
      !restrictedUser &&
      !isReportViewer;
    const showPayScalePulse =
      launchDarklyFeatureFlags && launchDarklyFeatureFlags['payscale-pulse'] && !restrictedUser && !isReportViewer;
    const useNewUploadPage = launchDarklyFeatureFlags['market-pay-upload-page'];
    const showUserVoice = launchDarklyFeatureFlags && launchDarklyFeatureFlags['user-voice'];
    const reportWriterNewEnabled = launchDarklyFeatureFlags && launchDarklyFeatureFlags['rw-react'];

    let bottomNavItems = (
      <React.Fragment>
        {isAnyAdmin && (
          <li
            className={classnames('nav-list__item', { show: section === SECTIONS.ADMIN })}
            onClick={section !== SECTIONS.ADMIN ? this.showSection.bind(this, SECTIONS.ADMIN) : this.hideSection}
            onMouseEnter={isNotIframed && this.showSection.bind(this, SECTIONS.ADMIN)}
            onMouseLeave={isNotIframed && this.hideSection}
          >
            <NavSection
              icon="icon-cog"
              iconHasCircle={true}
              title="Admin"
              navCollapsed={navCollapsed}
              links={[
                {
                  name: 'Group Administration',
                  to: `${IFRAME_URL}/permissions/group-admin`,
                  visible: showGroupAdminLink
                },
                {
                  name: 'System Configuration',
                  to: {
                    pathname: `${IFRAME_URL}/permissions/group-admin-edit`,
                    search: systemConfigSearch
                  },
                  isActive: (match, location) => {
                    return location.search.indexOf(systemConfigSearch) !== -1;
                  },
                  visible: showSystemConfig
                },
                {
                  name: 'Group Configuration',
                  to: {
                    pathname: `${IFRAME_URL}/permissions/group-admin-edit`,
                    search: groupConfigSearch
                  },
                  isActive: (match, location) => {
                    return location.search.indexOf(groupConfigSearch) !== -1;
                  },
                  visible: showGroupConfigLink
                },
                {
                  name: 'User Administration',
                  to: {
                    pathname: `${IFRAME_URL}/permissions/group-admin-edit`,
                    search: userAdminSearch
                  },
                  isActive: (match, location) => {
                    return location.search.indexOf(userAdminSearch) !== -1;
                  },
                  visible: showUserAdminLink
                },
                {
                  name: 'Database Utilities',
                  to: `${IFRAME_URL}/merit-admin`,
                  visible: isAnyAdmin
                },
                {
                  name: 'Upload HRIS Data',
                  to: !useNewUploadPage ? `${IFRAME_URL}/spooler/feed-pre-upload` : '/upload',
                  visible: showUploadHRISData
                },
                {
                  name: 'Upload Survey Data',
                  to: {
                    pathname: `${IFRAME_URL}/merit-admin/survey_lib`,
                    search: '?active_tab=1'
                  },
                  isActive: (match, location) => {
                    return location.search.indexOf('?active_tab=1') !== -1;
                  },
                  visible: showUploadSurveyData
                },
                {
                  name: 'SFTP Setup',
                  to: '/sftp-setup',
                  visible: superAdmin
                },
                {
                  name: 'MarketPay Utilities',
                  to: `${IFRAME_URL}/merit-admin/admin-tools`,
                  visible: superAdmin
                },
                {
                  name: 'MarketPay Internal',
                  to: '/admin/marketpay-internal',
                  visible: superAdmin
                }
              ]}
            />
          </li>
        )}
        <li
          className={classnames('nav-list__item', { show: section === SECTIONS.RESEARCH })}
          onClick={this.goToPSResearch}
        >
          <NavSection
            icon="icon-beaker"
            iconHasCircle={true}
            title="Payscale Research"
            navCollapsed={navCollapsed}
            onClick={this.goToPSResearch}
          />
        </li>
        <li
          className={classnames('nav-list__item', { show: section === SECTIONS.HELP })}
        >
          <NavSection
            icon="icon-help"
            iconHasCircle={true}
            title="Help"
            navCollapsed={navCollapsed}
            customHref={isProduction() ? SFCONNECT.PROD_URL : SFCONNECT.UAT_URL}
          />
        </li>
      </React.Fragment>
    );
    let bottomNav = navCollapsed ? <ul className="nav-list__bottom">{bottomNavItems}</ul> : null;

    const globalJobMatchingEnabled =
      launchDarklyFeatureFlags && launchDarklyFeatureFlags['global-job-matching'] === true;
    const globalJobMatchingLabel = launchDarklyFeatureFlags && launchDarklyFeatureFlags['glojam-v2'] ? 'Price at Scale' : 'Global Job Matching'
    const globalJobMatchingEndpoint = launchDarklyFeatureFlags && launchDarklyFeatureFlags['glojam-v2'] ? 'strategy-based-pricing' : 'global-job-matching'
    const configurableDashboardEnabled =
      launchDarklyFeatureFlags && launchDarklyFeatureFlags['configurable-dashboard'] === true;
    const structureModelingOldLandingPageEnabled =
      launchDarklyFeatureFlags && launchDarklyFeatureFlags['structure-modeling-landing-page'] === true;

return (
      <aside className={`${navCollapsed ? `nav-panel--collapsed` : 'nav-panel'}`}>
        <Logo logoLinkTo={isReportViewer ? '/reports/library' : '/'} navCollapsed={navCollapsed} />
        <NavToggle navCollapsed={navCollapsed} toggleCollapse={e => this.toggleCollapse(e)} />
        <nav className="nav">
          <ul className="nav-list">
            {configurableDashboardEnabled && (
              <li
                className={classnames('nav-list__item', { show: section === SECTIONS.DASHBOARD })}
                onClick={this.goToDashboard}
              >
                <NavSection
                  icon="icon-list-alt"
                  title="Dashboard"
                  navCollapsed={navCollapsed}
                  onClick={this.goToDashboard}
                />
              </li>
            )}
            <li
              className={classnames('nav-list__item', { show: section === SECTIONS.MARKET_ANALYSIS })}
              onClick={
                section !== SECTIONS.MARKET_ANALYSIS
                  ? this.showSection.bind(this, SECTIONS.MARKET_ANALYSIS)
                  : this.hideSection
              }
              onMouseEnter={isNotIframed && this.showSection.bind(this, SECTIONS.MARKET_ANALYSIS)}
              onMouseLeave={isNotIframed && this.hideSection}
            >
              {showMarketAnalysis && (
                <NavSection
                  icon="icon-chart-line"
                  title="Market Analysis"
                  navCollapsed={navCollapsed}
                  links={[
                    {
                      name: 'Market Price a Job',
                      to: `${IFRAME_URL}/pricing2/price`,
                      visible: showPricing
                    },
                    {
                      name: 'Market Price a Job (New)',
                      to: {
                        pathname: `/market-analysis/market-pricing`,
                        state: { bulkPricing: false }
                      },
                      visible: showPricing,
                      isActive: (match, location) => {
                        return (
                          location.pathname.includes('market-analysis/market-pricing') ||
                          location.pathname.includes('market-analysis/jobs')
                        );
                      }
                    },
                    {
                      name: globalJobMatchingLabel,
                      to: `/market-analysis/${globalJobMatchingEndpoint}`,
                      visible: showGlobalJobPricing && globalJobMatchingEnabled && sameOrgAndGroup,
                      isActive: (match, location) => {
                        return location.pathname.includes(`market-analysis/${globalJobMatchingEndpoint}`);
                      }
                    },
                    {
                      name: 'Differentials Engine',
                      to: `/market-analysis/differentials-engine`,
                      visible: showPayScalePulse
                    },
                    {
                      name: 'Browse Survey Library',
                      to: `${IFRAME_URL}/merit-admin/survey_lib`,
                      visible: showBrowseSurveyLibrary
                    },
                    {
                      name: 'Survey Participation',
                      to: `${IFRAME_URL}/pcenter/pcenter`,
                      visible: showParticipationCenter
                    },
                    {
                      name: 'Edit Survey Sources',
                      to: `${IFRAME_URL}/merit-admin/sources-admin`,
                      visible: showEditSurveySources
                    },
                    {
                      name: 'Survey Library Update',
                      to: `${IFRAME_URL}/merit-admin/slu/slu`,
                      visible: showLibraryUpdate
                    },
                    {
                      name: 'Private Survey Sources',
                      to: `${IFRAME_URL}/merit-admin/sources`,
                      visible: showPrivateSurveySources
                    },
                    {
                      name: 'Private Survey Jobs',
                      to: `${IFRAME_URL}/merit-admin/survey_jobs`,
                      visible: showPrivateSurveyJobs
                    },
                    {
                      name: 'Job Matching',
                      to: '/market-analysis/job-matching/',
                      visible: showRulesBasedPricing && !readOnlyUser
                    },
                    {
                      name: 'Rules Based Pricing',
                      isActive: (match, location) => {
                        return location.pathname.includes('rules-based-pricing');
                      },
                      to: '/market-analysis/rules-based-pricing/',
                      visible: showRulesBasedPricing && !readOnlyUser
                    }
                  ]}
                />
              )}
            </li>
            {showReports && (
              <li
                className={classnames('nav-list__item', { show: section === SECTIONS.REPORTS })}
                onClick={
                  section !== SECTIONS.REPORTS ? this.showSection.bind(this, SECTIONS.REPORTS) : this.hideSection
                }
                onMouseEnter={isNotIframed && this.showSection.bind(this, SECTIONS.REPORTS)}
                onMouseLeave={isNotIframed && this.hideSection}
              >
                <NavSection
                  icon="icon-doc-text"
                  title="Reports"
                  navCollapsed={navCollapsed}
                  links={reportWriterNewEnabled ? [
                    {
                      name: 'Report Library',
                      to: `/reports/library`,
                      isActive: (match, location) => {
                        return (
                          (location.pathname.indexOf('reports/library') !== -1 && location.pathname !== '/reports/library-new')  ||
                          location.hash.indexOf('#reportWriter') !== -1 ||
                          location.pathname.indexOf('#reportWriter') !== -1
                        );
                      },
                      visible: showReportLibrary
                    },
                    {
                      name: 'Data Mining',
                      to: {
                        pathname: `${IFRAME_URL}/report-writer/report-select`,
                        search: '?report_writer_mode=data_mining'
                      },
                      visible: showDataMining
                    },
                    {
                      name: 'Data Analytics',
                      to: {
                        pathname: `/iframe/module/`,
                        hash: 'dashboards'
                      },
                      isActive: (match, location) => {
                        return location.hash.indexOf('#dashboards') !== -1;
                      },
                      visible: showDataAnalytics
                    }
                  ] :
                  [
                    {
                      name: 'Report Library',
                      to: `/reports/library`,
                      isActive: (match, location) => {
                        return (
                          location.pathname.indexOf('reports/library') !== -1  ||
                          location.hash.indexOf('#reportWriter') !== -1 ||
                          location.pathname.indexOf('#reportWriter') !== -1
                        );
                      },
                      visible: showReportLibrary
                    },
                    {
                      name: 'Data Mining',
                      to: {
                        pathname: `${IFRAME_URL}/report-writer/report-select`,
                        search: '?report_writer_mode=data_mining'
                      },
                      visible: showDataMining
                    },
                    {
                      name: 'Data Analytics',
                      to: {
                        pathname: `/iframe/module/`,
                        hash: 'dashboards'
                      },
                      isActive: (match, location) => {
                        return location.hash.indexOf('#dashboards') !== -1;
                      },
                      visible: showDataAnalytics
                    }
                  ]
                }
                />
              </li>
            )}
            {showModeling && (
              <li
                className={classnames('nav-list__item', { show: section === SECTIONS.MODELING })}
                onClick={
                  section !== SECTIONS.MODELING ? this.showSection.bind(this, SECTIONS.MODELING) : this.hideSection
                }
                onMouseEnter={isNotIframed && this.showSection.bind(this, SECTIONS.MODELING)}
                onMouseLeave={isNotIframed && this.hideSection}
              >
                <NavSection
                  icon="icon-sliders"
                  title="Modeling"
                  navCollapsed={navCollapsed}
                  links={[
                    {
                      name: 'Model a Structure (Classic)',
                      to: `${IFRAME_URL}/structures/strucselect/structure-select`,
                      visible: showStructureModeling && structureModelingOldLandingPageEnabled
                    },
                    {
                      name: 'Model a Structure',
                      to: `/structure-modeling`,
                      visible: showStructureModeling,
                      isActive: (_match, location) => {
                        return location.pathname.indexOf('/structure-modeling') !== -1;
                      }
                    },
                    {
                      name: 'Model a Merit Matrix',
                      to: `${IFRAME_URL}/matrix2/matrix-select`,
                      visible: showModelingMatrix
                    },
                    {
                      name: 'Job Based Ranges',
                      to: `/ranges`,
                      visible: showJobBasedRanges,
                      isActive: (_match, location) => {
                        return location.pathname.indexOf('/ranges') !== -1;
                      }
                    }
                  ]}
                />
              </li>
            )}

            {showJDXpert && (
              <li
                className={classnames('nav-list__item', { show: section === SECTIONS.JDXPERT })}
                onClick={this.goToJDXpert}
              >
                <NavSection
                  isSVG
                  icon="/view/static/mp/images/jdx_icon.svg"
                  title="JDXpert"
                  navCollapsed={navCollapsed}
                  onClick={this.goToJDXpert}
                />
              </li>
            )}
            <li
              className={classnames('nav-list__item nav-list__item separator', { show: section === SECTIONS.OUR_DATA })}
              onClick={
                section !== SECTIONS.OUR_DATA ? this.showSection.bind(this, SECTIONS.OUR_DATA) : this.hideSection
              }
              onMouseEnter={isNotIframed && this.showSection.bind(this, SECTIONS.OUR_DATA)}
              onMouseLeave={isNotIframed && this.hideSection}
            >
              {showOurData && (
                <NavSection
                  icon="icon-users"
                  title="Our Data"
                  navCollapsed={navCollapsed}
                  links={[
                    {
                      name: 'Employees',
                      to: `${IFRAME_URL}/hris/employee/employees`,
                      visible: showEmployees
                    },
                    {
                      name: 'Jobs',
                      to: `${IFRAME_URL}/hris/job/jobs`,
                      visible: showJobs
                    },
                    {
                      name: dynamicSalaryRangeLabel,
                      to: `${IFRAME_URL}/hris/structures/structures`,
                      visible: showStructures
                    }
                  ]}
                />
              )}
            </li>
            {!navCollapsed ? bottomNavItems : null}
          </ul>
          {bottomNav}
          {showUserVoice &&
            <ul className="nav-list__bottom nav-list__idea">
              <li
                className={classnames('idea')}
                onClick={() => this.goToUserVoice(session.organization.masterAccountId)}
              >
                <NavSection
                  icon="icon-lightbulb"
                  iconHasCircle={true}
                  title="Submit an Idea"
                  navCollapsed={navCollapsed}
                  onClick={() => this.goToUserVoice(session.organization.masterAccountId)}
                />
              </li>
            </ul>
          }
        </nav>
      </aside>
    );
  }
}

export default withRouter(NavPanel);
